import styled from '@emotion/styled';
import { ThemeIcon } from '@mantine/core';

type NodeContainerProps = {
  isSelected?: boolean;
};

export const NodeContainer = styled('div')<NodeContainerProps>(
  ({ theme, isSelected }) => ({
    width: 260,
    boxSizing: 'border-box',
    border: isSelected
      ? `1px solid ${theme.colors.blue[6]}`
      : `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.md,
    backgroundColor:
      theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
    boxShadow: theme.shadows.sm,
    transition: 'box-shadow 150ms ease, transform 150ms ease',
    '&:hover': {
      boxShadow: theme.shadows.md,
    },
    position: 'relative',
  })
);

export const NodeHeader = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing.xs,
  paddingRight: theme.spacing.xs,
  paddingTop: theme.spacing.xs,
  paddingBottom: theme.spacing.xs,
  position: 'relative',
  backgroundColor:
    theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
  borderTopLeftRadius: theme.radius.md,
  borderTopRightRadius: theme.radius.md,
  borderBottom: `1px solid ${
    theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2]
  }`,
}));

export const NodeHeaderRow = styled('div')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
});

export const NodeHeaderInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing.xs,
  minWidth: 0,
  flex: 1,
  transition: 'padding-right 150ms ease',
  '[data-graph-node]:hover &, [data-graph-node]:focus-within &': {
    paddingRight: 92,
  },
}));

export const NodeHeaderTitle = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  overflow: 'hidden',
});

export const NodeBody = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing.xs,
  paddingRight: theme.spacing.xs,
  paddingTop: theme.spacing.xs,
  paddingBottom: theme.spacing.xs,
  borderBottom: `1px solid ${
    theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2]
  }`,
}));

export const NodeFooter = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing.xs,
  paddingRight: theme.spacing.xs,
  paddingTop: theme.spacing.xs,
  paddingBottom: theme.spacing.xs,
}));

export const NodeHeaderIcon = styled(ThemeIcon)<any>(({ theme }) => ({
  color:
    theme.colorScheme === 'dark' ? theme.colors.gray[1] : theme.colors.gray[7],
  border: 'none',
  background: 'none',
}));

export const NodeActions = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  right: 0,
  transform: 'translateY(-50%)',
  paddingLeft: theme.spacing.xs,
  backgroundColor:
    theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 150ms ease',
  zIndex: 2,
  '.graph-node-actions': {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  '[data-graph-node]:hover &, [data-graph-node]:focus-within &': {
    opacity: 1,
    pointerEvents: 'auto',
  },
}));
